{
  "absoluteDirectionPad": {
    "title": "Up (↑ / W)",
    "ariaLabel": "Large move: up",
    "title2": "Down (↓ / S)",
    "ariaLabel2": "Large move: down",
    "title3": "Left (← / A)",
    "ariaLabel3": "Large move: left",
    "title4": "Right (→ / D)",
    "ariaLabel4": "Large move: right",
    "title5": "Up (Shift+↑ / Shift+W)",
    "ariaLabel5": "Small move: up",
    "title6": "Down (Shift+↓ / Shift+S)",
    "ariaLabel6": "Small move: down",
    "title7": "Left (Shift+← / Shift+A)",
    "ariaLabel7": "Small move: left",
    "title8": "Right (Shift+→ / Shift+D)",
    "ariaLabel8": "Small move: right"
  },
  "cameraControlPanel": {
    "text": "Self-return couldn't be switched.",
    "text2": "The camera settings couldn't be loaded.",
    "label": "Change",
    "title": "Change self-return setting",
    "text3": "Turn self-return ",
    "text4": "off",
    "text5": "on",
    "text6": "?",
    "text7": "The camera will restart.",
    "title2": "Error"
  },
  "homePositionRow": {
    "text": "Home position"
  },
  "homePositionUpdateDialog": {
    "text": "Updating...",
    "title": "Confirm home position update",
    "text2": "Update the home position to the current camera position?"
  },
  "opticalZoom": {
    "title": "Zoom out (Z)",
    "ariaLabel": "Zoom out",
    "title2": "Zoom in (X)",
    "ariaLabel2": "Zoom in",
    "title3": "1x zoom",
    "text": "Hide ruler",
    "text2": "Show ruler",
    "ariaLabel3": "Ruler"
  },
  "panelHeader": {
    "text": "PTZ control",
    "ariaLabel": "Close PTZ panel"
  },
  "presetDeleteDialog": {
    "text": "Deleting...",
    "title": "Confirm preset deletion",
    "text2": "」 will be deleted. Continue?"
  },
  "presetRow": {
    "ariaLabel": "Go to preset {{name}}{{value}}",
    "ariaLabel2": "Delete preset {{name}}",
    "text": " (selected)"
  },
  "presetSection": {
    "text": "Presets",
    "text2": "+ Add preset",
    "text3": "The presets couldn't be loaded."
  },
  "ptzPresetModal": {
    "handleError": "The preset couldn't be created.",
    "title": "Register preset",
    "text": "The current camera position will be saved as a preset.",
    "helperText": "{{length}}/{{MAX_TITLE_LENGTH}} characters",
    "label": "Title",
    "text2": "The maximum number of presets has been reached."
  },
  "relativeDirectionPad": {
    "title": "Up (↑ / W)",
    "ariaLabel": "Move: up",
    "title2": "Down (↓ / S)",
    "ariaLabel2": "Move: down",
    "title3": "Left (← / A)",
    "ariaLabel3": "Move: left",
    "title4": "Right (→ / D)",
    "ariaLabel4": "Move: right"
  },
  "selfReturnToggle": {
    "text": "Self-return",
    "text2": "After 10 min"
  },
  "directionPadParts": {
    "title": "Home position (C)",
    "ariaLabel": "Home position"
  },
  "cameraSidebar": {
    "ariaLabel": "Cameras tab",
    "label": "Cameras",
    "ariaLabel2": "Detection results tab",
    "label2": "Detection results",
    "text": "360° camera"
  },
  "canvasSeekbar": {
    "renderPinSummaryRow": "Detection target:",
    "renderPinSummaryRow2": "Detection condition:",
    "renderPinSummaryRow3": "Target cameras:",
    "renderPinSummaryRow4": "Period:",
    "alt": "AI detection result",
    "ariaLabel": "Narrow display range",
    "ariaLabel2": "Widen display range"
  },
  "clipCapacityErrorModal": {
    "label": "Go to clips",
    "title": "Clip storage error",
    "text": "The clip storage limit has been reached.",
    "text2": "Delete clips that are no longer needed, or contact your administrator."
  },
  "clipCreateModal": {
    "label": "10 min",
    "label2": "30 min",
    "label3": "60 min",
    "label4": "2 hours",
    "label5": "3 hours",
    "label6": "1 hour",
    "label7": "6 hours",
    "label8": "12 hours",
    "label9": "24 hours",
    "text": "0s",
    "push": "{{h}}h",
    "push2": "{{m}}m",
    "push3": "{{s}}s",
    "text2": "{{sec}}s",
    "text3": "{{m}}m {{s}}s",
    "text4": "Creating...",
    "text5": "Clip in progress",
    "text6": "Create clip",
    "title": "Create clip",
    "alert": "Creating the clip. Keep this screen open until it finishes.",
    "alert2": "Another clip is being created for this camera. Wait until it finishes.",
    "label10": "Movie",
    "label11": "Timelapse",
    "text7": "Quick select",
    "text8": "Start time",
    "text9": "End time",
    "text11": "Clips can be up to 3 hours long.",
    "text12": "The output length must be at least 10 seconds.",
    "text13": "The most recent recording period is set automatically. Change the times directly in the start and end fields below.",
    "text14": "Recording period:",
    "ariaLabel": "Recording period length",
    "text15": "Output length",
    "ariaLabel2": "Output length value",
    "button": "sec",
    "button2": "min",
    "text16": " of recording can produce up to ",
    "text17": "The maximum output length is ",
    "text18": " seconds (",
    "text19": " minutes).",
    "text20": "The selected recording period can produce a timelapse of up to ",
    "text21": ".",
    "text22": "Extend the recording period or shorten the output length.",
    "text23": "The clip can be created.",
    "text24": "to",
    "text25": "will be turned into a clip.",
    "text26": "The output length must be at least 1 second.",
    "text27": "There are no recordings in the selected period.",
    "minDateTooltip": "The timelapse recording period can be extended with the cloud recording option."
  },
  "footerMenu": {
    "text": "Change layout",
    "text2": "Change playback mode",
    "text3": "AI detection alerts",
    "text4": "In this browser: ",
    "text5": "On",
    "text6": "Off",
    "text7": "Add viewer",
    "text8": "Back to admin console"
  },
  "layoutSelectModal": {
    "label": "Clear all",
    "label2": "Apply",
    "title": "Change layout",
    "text": "Split direction",
    "label3": "Vertical",
    "label4": "Horizontal",
    "text2": "Number of splits",
    "text3": "Select cameras",
    "text4": "Selected area: {{lockedAreaName}}",
    "text5": "Selected areas: {{uniqueAreaCount}}/{{MAX_UNIQUE_AREAS}}",
    "text6": "Multi-view can only show cameras from the same area at once. Remove cameras from other areas.",
    "text7": "split",
    "label5": "Area",
    "placeholder": "Select an area",
    "label6": "Camera",
    "placeholder2": "Select a camera"
  },
  "liveButton": {
    "text": "Playback mode"
  },
  "mobileCameraList": {
    "text": "360° camera"
  },
  "mobileFullscreenView": {
    "ariaLabel": "Exit full screen"
  },
  "multiViewCell": {
    "ariaLabel": "Cell {{value}} (empty)",
    "ariaLabel2": "Add camera",
    "ariaLabel3": "Cell {{value}} (connecting)",
    "ariaLabel4": "Cell {{value}} (error)",
    "text": "Connection error",
    "text2": "The connection failed.",
    "ariaLabel5": "Retry",
    "ariaLabel6": "Cell {{value}} ({{cameraName}})",
    "ariaLabel7": "Zoom in",
    "ariaLabel8": "Zoom level",
    "ariaLabel9": "Zoom out",
    "ariaLabel10": "Action menu",
    "text3": "Show in single view",
    "text4": "End PTZ control",
    "text5": "PTZ control"
  },
  "multiViewCellContainer": {
    "text": "There's no recording at this time.",
    "text2": "The recording couldn't be loaded.",
    "ariaLabel": "Back to Live",
    "livePlaybackError": "The live stream couldn't be played. Try again.",
    "retryLivePlayback": "Retry live playback",
    "cellLabel": "Video cell for {{cameraName}}",
    "selectCell": "Select cell for {{cameraName}}"
  },
  "playbackControls": {
    "title": "Previous frame",
    "title2": "Back 10 seconds",
    "text": "Pause",
    "text2": "Play",
    "title3": "Forward 10 seconds",
    "title4": "Next frame"
  },
  "ptzOverlay": {
    "label": "Move up-left",
    "label2": "Move up",
    "label3": "Move up-right",
    "label4": "Move down-left",
    "label5": "Move down",
    "label6": "Move down-right",
    "text": "The camera couldn't be moved.",
    "edgeTimeout": "The camera isn't responding. Check the camera's power and network connection."
  },
  "recordingSourceToggle": {
    "trigger": "Cloud recording",
    "menu": "Cloud",
    "trigger2": "Local recording",
    "menu2": "Local",
    "ariaLabel": "Recording playback source"
  },
  "streamModeSelectModal": {
    "label": "Apply",
    "title": "Select playback mode",
    "text": "Applies to all live streams open in this browser.",
    "text2": "Low latency",
    "text3": "Stable",
    "ariaLabel": "Playback mode"
  },
  "streamingErrorModal": {
    "title": "The connection to the streaming server failed.",
    "description": "Try again later, or contact support.",
    "title2": "The stream couldn't be prepared.",
    "title3": "The streaming session couldn't be established.",
    "title4": "The connection to the stream was lost.",
    "description2": "Check your network connection. If the problem persists, try reconnecting.",
    "title5": "The video stream wasn't found.",
    "description3": "Check that the camera is configured correctly.",
    "title6": "A network error occurred.",
    "description4": "Check your internet connection and try again.",
    "text": "Retried",
    "text2": " times",
    "button": "Reconnect",
    "button2": "Back to camera list"
  },
  "videoPlayer": {
    "text": "Part of the cloud recording is missing.",
    "text2": "It may be playable from the local recording.",
    "text3": "There's no recording at this time.",
    "ariaLabel": "Back to Live",
    "ariaLabel2": "Switch to local recording",
    "text4": "Loading recording..."
  },
  "viewerAiDetectionAlert": {
    "text": "20 or more new detection results",
    "text2": "{{count}} new detection results",
    "text3": "New detection results",
    "ariaLabel": "Close AI detection alert",
    "alt": "Detection image for {{detectionName}}",
    "button": "View",
    "text4": "Closes automatically in 5 seconds"
  },
  "viewerFooter": {
    "text": "AI detection",
    "enqueueSnackbar": "The voice call couldn't be started.",
    "text2": "Close clip creation",
    "text3": "Create clip",
    "text4": "Close zoom",
    "text5": "Zoom",
    "text6": "Exit full screen",
    "text7": "Full screen",
    "text8": "Close AI detection",
    "text9": "Close menu",
    "text10": "Menu",
    "text11": "Turn on microphone",
    "text12": "Turn off microphone",
    "text13": "End call",
    "text14": "Start call",
    "text15": "Disable PTZ",
    "text16": "Enable PTZ",
    "ariaLabel": "PTZ control",
    "text17": "Close seek bar",
    "text18": "View recordings",
    "title": "Take snapshot",
    "ariaLabel2": "Rotate screen",
    "text19": "Voice call started",
    "text20": "Close map",
    "text21": "Open map"
  },
  "viewerHeader": {
    "button": "Exit multi-view",
    "ariaLabel": "Open camera list"
  },
  "viewerInviteDialog": {
    "cameraInfoError": "The camera information couldn't be loaded. Reload the page.",
    "enqueueSnackbar": "The viewer permissions couldn't be loaded.",
    "enqueueSnackbar2": "Invitation email sent",
    "text": "The invitation email couldn't be sent.",
    "text2": "Sending...",
    "text3": "Send",
    "title": "Grant view permission",
    "placeholder": "Email address"
  },
  "zoomBar": {
    "title": "Zoom in",
    "title2": "Zoom out"
  },
  "errorBoundary": {
    "text": "An error occurred.",
    "text2": "An unexpected error occurred.",
    "button": "Retry",
    "button2": "Reload page"
  },
  "types": {
    "janusInitFailed": "The streaming server couldn't be initialized.",
    "janusAttachFailed": "The streaming plugin couldn't be attached.",
    "janusSessionFailed": "The streaming session couldn't be created.",
    "connectionLost": "The connection was lost.",
    "streamNotFound": "The stream wasn't found.",
    "networkError": "A network error occurred.",
    "roomJoinFailed": "The audio room couldn't be joined.",
    "roomCreateFailed": "The audio room couldn't be created.",
    "permissionDenied": "Microphone access was denied.",
    "microphoneError": "The microphone couldn't be initialized.",
    "audioConnectionLost": "The audio connection was lost.",
    "commandFailed": "The camera operation failed.",
    "presetLoadFailed": "The presets couldn't be loaded.",
    "presetSaveFailed": "The preset couldn't be saved.",
    "homePositionFailed": "The home position operation failed.",
    "cameraNotFound": "The camera wasn't found.",
    "cameraOffline": "The camera is offline.",
    "cameraAccessDenied": "Access to the camera was denied.",
    "text": "An unknown error occurred."
  },
  "useJanusConnection": {
    "message": "The connection to the stream couldn't be restored."
  },
  "useMultiStreaming": {
    "setError": "Reconnection failed {{MAX_RETRY_COUNT}} times."
  },
  "useMultiViewRecordingSession": {
    "onError": "The recording couldn't be loaded."
  },
  "useMultiViewStreaming": {
    "error": "The connection failed."
  },
  "usePtzCommands": {
    "text": "The presets couldn't be loaded.",
    "getErrorMessage": "The camera couldn't be moved.",
    "getErrorMessage2": "The zoom operation failed.",
    "getErrorMessage3": "The zoom couldn't be reset.",
    "getErrorMessage4": "The camera couldn't be moved to the preset.",
    "getErrorMessage5": "The preset couldn't be deleted.",
    "getErrorMessage6": "The home position couldn't be set.",
    "getErrorMessage7": "The camera couldn't be moved to the home position.",
    "edgeTimeout": "The camera isn't responding. Check the camera's power and network connection."
  },
  "useRecordingSession": {
    "onError": "The recording information couldn't be loaded.",
    "onError2": "The recording couldn't be loaded."
  },
  "useViewerViewState": {
    "text": "Camera"
  },
  "desktopViewerLayout": {
    "aiAlertDetectionName": "{{cameraName}} / {{detectionName}}",
    "unknownCamera": "Unknown camera",
    "clipAlreadyProcessingMessage": "Another clip is being created for this camera. Wait until it finishes.",
    "setClipCreateError": "Required information is missing.",
    "setClipCreateError2": "The camera information couldn't be loaded.",
    "setClipCreateError3": "The specified output length is invalid.",
    "message": "Clip creation started",
    "message2": "The frame couldn't be captured.",
    "text": "Camera",
    "message3": "Snapshot saved",
    "message4": "The snapshot couldn't be saved.",
    "text2": "Multi-view ({{splitNumber}} split)",
    "text3": "AI detection",
    "text4": "No AI detections configured",
    "text5": "AI features are disabled",
    "text6": "Detection condition matched",
    "message5": "The detection can't be edited because the tenant information couldn't be loaded.",
    "message6": "The detection can't be edited because its details couldn't be loaded. Try again later.",
    "message7": "The detection can't be created because the tenant information couldn't be loaded.",
    "message8": "{{detectionName}} {{value}}",
    "message9": "The detection to stop couldn't be loaded.",
    "message10": "{{detectionName}} stopped",
    "message11": "{{detectionName}} couldn't be stopped.",
    "button": "Go to captures",
    "text7": "The clip couldn't be created.",
    "text8": "updated",
    "text9": "started"
  },
  "errorView": {
    "text": "The camera wasn't found, or view permission isn't granted. Ask the user who invited you to check your view permission.",
    "text2": "The camera information couldn't be loaded.",
    "text3": "An error occurred.",
    "button": "Retry"
  },
  "loadingView": {
    "text": "Loading camera information..."
  },
  "janusStreamAdapter": {
    "handleError": "Session initialization failed: {{value}}",
    "handleError2": "The connection to the stream was lost.",
    "handleError3": "Plugin attach failed: {{value}}",
    "handleError4": "WebRTC answer creation failed: {{value}}",
    "handleError5": "Track processing error: {{value}}"
  },
  "playoutDelay": {
    "realtime": "Low latency",
    "stable": "Balanced",
    "highStable": "Stable",
    "superStable": "More stable",
    "realtime2": "For stable networks. No added delay.",
    "stable2": "For minor stuttering. Adds about 0.5 seconds of delay.",
    "highStable2": "For unstable networks. Adds about 1 second of delay.",
    "superStable2": "To keep video from freezing as much as possible. Adds about 1.5 seconds of delay."
  },
  "useStreamAdapter": {
    "message": "Reconnection failed {{MAX_RETRY_COUNT}} times."
  },
  "cameraAccess": {
    "viewerCameraForbiddenMessage": "View permission for this camera isn't granted."
  },
  "ptzLogic": {
    "message": "Enter a preset name.",
    "message2": "A preset with the same name already exists.",
    "message3": "Up to {{MAX_PRESETS}} presets are allowed."
  },
  "liveAudioToggleButton": {
    "unmute": "Turn on audio",
    "mute": "Turn off audio",
    "disabledDuringCall": "Camera audio can't be played during a call"
  },
  "recordingAudioSourceButton": {
    "label": "Choose sounds to play",
    "camera": "Camera audio",
    "talk": "Talk recording"
  },
  "useVideoRoomTalk": {
    "forbidden": "Calls aren't available for this camera.",
    "notStreaming": "The call couldn't be started. The camera may not be streaming.",
    "busy": "Someone else is already on a call.",
    "startFailed": "The call couldn't be started.",
    "disconnected": "The call was disconnected.",
    "playbackRejected": "The call ended because audio couldn't be played."
  },
  "talkOverlayControls": {
    "region": "Call controls",
    "talking": "On a call",
    "micOn": "Turn on microphone",
    "micOff": "Turn off microphone",
    "end": "End call"
  }
}
